import { endpoints } from '@/api/endpoints';
import { MasterCrud } from '@/components/MasterCrud';
import { Input } from '@/components/ui/Input';

interface BrandRow {
  id: number;
  name: string;
  products_count?: number;
}
interface BrandForm {
  name: string;
}

export function BrandsPage() {
  return (
    <MasterCrud<BrandRow, BrandForm>
      title="Brands"
      description="The makers of the products you sell."
      listUrl={endpoints.brands}
      itemUrl={endpoints.brand}
      queryKey="brands"
      newForm={() => ({ name: '' })}
      toForm={(r) => ({ name: r.name })}
      toBody={(f) => ({ name: f.name.trim() })}
      columns={[
        { key: 'name', header: 'Name', cell: (r) => r.name },
        {
          key: 'products',
          header: 'Products',
          className: 'text-right',
          cell: (r) => r.products_count ?? 0,
        },
      ]}
      formFields={(value, setValue) => (
        <Input
          name="name"
          label="Brand name"
          autoFocus
          value={value.name}
          onChange={(e) => setValue({ ...value, name: e.target.value })}
          placeholder="e.g. Sleepwell"
        />
      )}
    />
  );
}
